import { render } from "./RegisTer.vue?vue&type=template&id=27be2d17"
import script from "./RegisTer.vue?vue&type=script&lang=js"
export * from "./RegisTer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__